import React, { useEffect, useState } from "react";
import { Card, Button, Typography, Row, Col } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { portalActions } from "store/portal-slice";
import { useDispatch } from "react-redux";
import { Grid, theme, Spin } from "antd";
import BrandColors from "@brand-colors";
import { clearLocalStore } from "helpers/localStoreSrv";
import AddressVerification from "pages/AddressVerification/AddressVerification";
import whitelabelConfig from "@whitelabel-config";
import PendingSurveyList from "./../../components/PendingSurveyList/PendingSurveyList";
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import useToasterMessage from "helpers/useToasterMessage";
import { useValidateVisibilityHook } from "./useValidateVisbiltyHook";
import { LANGUAGES, getLanguageId } from "./../../constants/supported_lang";
import PendingSurveyListThankYou from "components/PendingSurveyList/PendingSurveyListThankYou";
import DOMPurify from "dompurify";
import { usePageTitle } from "helpers/usePageTitle";
const { Title } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;
const ThankYou = () => {
  const portalMicrositeSession = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  const { initAuth } = useAuthProvider();
  const { t } = useTranslation();
  usePageTitle("THANKYOU.PAGE_TITLE", `Thank You - ${process.env.REACT_APP_PRODUCT}`);
  const dispatch = useDispatch();
  const { thankyouState } = useSelector((state: any) => state.portal.uiState);
  const { familySurveyPendingSurveys } = useSurveySrv();
  const { getSurevyData, getLanguageTranslations } = useSurveySrv();
  const authState = useSelector((state: any) => state.portal.authSession);
  const navigate = useNavigate();
  const { token } = useToken();
  const screens = useBreakpoint();
  const [message, setMessage] = useState(null);
  const [pendingList, setpendingList] = useState(true);
  const { UseToaster } = useToasterMessage();
  const appUiState = useSelector((state: any) => state.portal.uiState);
  const [thanksText, setThanksText] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState(appUiState?.Language);
  const [isLoading, setIsLoading] = useState(true); // Start with loading state
  const [cnfmText, setCnfmText] = useState("");
  const [renderHtml, setRenderHtml] = useState("");
  const [renderHtmlOrderTwo, setRenderHtmlOrderTwo] = useState("");
  const [thankYouText, setThankYouText] = useState("");
  const [confirmData, setConfirmData] = useState();
  const [isConfirmTq, setIsConfirmTq] = useState(false);
  const validateVisibilityRule = useValidateVisibilityHook(confirmData);
  const formData = useSelector((state: any) => state.portal.formData);
  const [isRuleBasedSurvey, setIsRuleBasedSurvey] = useState(false);
  const surveyLanguage = useSelector(
    (state: any) => state.portal.uiState.SurveyLanguage
  );
  const [isRightAlign, setIsRightAlign] = useState(false);
  const [dataFetched, setDataFetched] = useState(false); // Add a flag to track if data has been fetched

  const handleChildData = (dataFromChild: any) => {
    console.log("Data from child:", dataFromChild);
    UseToaster({
      type: "success",
      message: dataFromChild,
      description: "",
    });
    setMessage(dataFromChild);
  };

  const handlePendingSurvey = () => {
    sessionStorage.clear();
    initAuth("PII");
  };

  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };

  useEffect(() => {
    console.log("appUiState?.Language", appUiState?.Language);
    setCurrentLanguage(appUiState?.Language);
  }, [appUiState]);

  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          surveyLanguage
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign, surveyLanguage]);

  useEffect(() => {
    if (dataFetched) return; // Don't refetch if data has already been loaded

    const fetchSurveyData = async () => {
      setIsLoading(true);
      try {
        const surveyResponse = await getSurevyData();
        const surveyData = surveyResponse?.data;

        const languageData = await getLanguageTranslations(
          surveyData.TranslationGroupID,
          getLanguageId(currentLanguage)
        );
        const languageCode = getIdByCode(currentLanguage);
        const updatedLangData =
          languageData?.data.filter(
            (item: any) => item.LanguageCode === languageCode
          ) || [];
        const agreeTextRes = updatedLangData.find(
          (item: any) => item.TextCode === process.env.REACT_APP_THAN_YOU
        );

        if (agreeTextRes?.TextValue) {
          setThanksText(agreeTextRes.TextValue);
        }

        if (surveyData.IsRuleBasedSurvey === true) {
          setIsRuleBasedSurvey(true);
          try {
            let data = await fetch(surveyData.SurveyUrl).then((res) => {
              return res.json();
            });
            setCnfmText(data.surveyConfirmations[0].confirmationText);
            setRenderHtml(data.surveyConfirmations[0].renderHtml);
            setThankYouText(data.surveyConfirmations[1].confirmationText);
            setRenderHtmlOrderTwo(data.surveyConfirmations[1].renderHtml);
            setConfirmData(data);

            const isConfirm = runVisibilityRule(data);
            setIsConfirmTq(isConfirm);
          } catch (error) {
            console.error("Error fetching survey URL data:", error);
            handleErrorNavigation(error, navigate, t);
          }
        }
        setDataFetched(true); // Mark data as fetched
      } catch (error) {
        console.error("Error in fetchSurveyData:", error);
        handleErrorNavigation(error, navigate, t);
      } finally {
        setIsLoading(false);
      }
    };

    if (!authState.is_authenticated) {
      const navParams = {
        state: {
          errorCode: "401",
          errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
          errorDescription: "",
        },
      };
      console.log(navParams);
      clearLocalStore();
      navigate("/error", navParams);
    } else {
      fetchSurveyData();
    }

    familySurveyPendingSurveys()
      ?.then((res) => {
        if (
          whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
          res.data.PendingSurveys &&
          res.data.PendingSurveys.length > 0
        ) {
          const sessionPayload = {
            pendingSurveys: res.data.PendingSurveys,
          };
          dispatch(portalActions.updateMicrositeSession(sessionPayload));
          let isFamilySurveyOpen = res.data.PendingSurveys.filter((m) => {
            return m.ActivityStatus === 120000000;
          });
          console.log("isFamilySurveyOpen ", isFamilySurveyOpen);
          if (isFamilySurveyOpen && isFamilySurveyOpen.length === 0) {
            setpendingList(false);
          }
        }
      })
      .catch((e) => {
        handleErrorNavigation(e, navigate, t);
      });
  }, [authState.is_authenticated, currentLanguage, dataFetched]);
useEffect(() => {
  // Push a new entry to the history stack
  window.history.pushState(null, "", window.location.href);

  const handlePopState = () => {
    // Push the user forward again to prevent going back
    window.history.pushState(null, "", window.location.href);
  };

  window.addEventListener("popstate", handlePopState);

  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
}, []);
  const runVisibilityRule = (data: any) => {
    console.log("data++", data);
    let visible = false;
    data.surveyConfirmations.forEach((obj: any, Index: number) => {
      console.log("obj", obj);
      if (obj.isVisibleConditionEnabled) {
        const visibilityRules: any = obj.visibleCondition.filterConditions;
        console.log("visibilityRules", visibilityRules);
        visibilityRules.forEach((element) => {
          const res: any = validateVisibilityRule(element, formData);
          console.log("forEach-", res);
          visible = res ? res : false;
        });
      }
    });
    return visible;
  };

  const styles = {
    section1: {
      alignItems: "center",
      backgroundColor: BrandColors.BUTTON_BG,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      color: token.colorBgContainer,
      padding: screens.md ? `15px` : "10px",
      borderRadius: "5px",
      textAlign: isRightAlign ? "right" : "",
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading3 : token.fontSizeHeading4,
      marginTop: "0",
      marginBottom: "20px",
      textAlign: isRightAlign ? "right" : "",
    },
    title1: {
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      marginTop: "0",
      marginBottom: "20px",
    },
    thankyoupage: {
      justifyContent: "center",
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
    },
  };

  // Render a loading spinner while data is being fetched
  if (isLoading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div data-testid="thankyou-page">
      <Row className="page-wrapper justify-content-md-center thankyoupage">
        <Col md={24} sm={24} style={{ width: "100%" }}>
          {isRuleBasedSurvey && (
            <div>
              {isConfirmTq ? (
                <div
                  role="region"
                  aria-label={t("THANKYOU.TITLE", { defaultValue: "Thank-you content" })}
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderHtml) }}
                  id="thanks-title" tabIndex={0}
                />
              ) : (
                <Row className="page-wrapper justify-content-md-center thankyoupage">
                  <Col md={24} sm={24}>
                    <Card className="hls-container">
                      <div className="card-body thank-container 1">
                        <div
                          id="thanks-content"
                          tabIndex={0}
                          style={styles.title}
                          role="region"
                          aria-label={t("THANKYOU.TITLE", { defaultValue: "Thank-you content" })}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(renderHtmlOrderTwo),
                          }}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
              )}
            </div>
          )}
          {!isRuleBasedSurvey && (
            <Card className="hls-container">
              <div className="card-body thank-container 2">
                {/* Only render content when data is available */}
                {thanksText ? (
                  <div
                    id="thanks-title1"
                    tabIndex={0}
                    role="region"
                    aria-label={t("THANKYOU.TITLE", { defaultValue: "Thank-you content" })}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(thanksText) }}
                  />
                ) : (
                  <div>
                    <Title style={styles.title} id="thankyou-title" tabIndex={0}>
                      {thankyouState.contentTitle
                        ? thankyouState.contentTitle
                        : t("THANKYOU.TITLE")}
                    </Title>
                    <Title style={styles.title1} id="thankyou-secondary" tabIndex={0}>
                      {thankyouState.TITLE_SECONDARY
                        ? thankyouState.TITLE_SECONDARY
                        : t("THANKYOU.TITLE_SECONDARY")}
                    </Title>
                    <div style={styles.section1} id="thankyou-content" tabIndex={0}>
                      {thankyouState.contentText
                        ? thankyouState.contentText
                        : t("THANKYOU.CONTENT_TEXT", {
                            PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
                          })}
                    </div>
                  </div>
                )}
              </div>
            </Card>
          )}
          {whitelabelConfig.uiSettings.isAddressVerificationEnabled &&
            !message && (
              <Card
                className="hls-container"
                title={`${
                  message === "Updated Successfully"
                    ? ""
                    : t("PROFILE_PAGE.ADDRESS_INFORMATION")
                }`}
                style={{ marginTop: 15, textAlign: "left", marginBottom: 15 }}
              >
                <div className="card-body thank-container 3">
                  <AddressVerification onDataFromChild={handleChildData} />
                </div>
              </Card>
            )}
        </Col>
        {whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
          portalMicrositeSession?.pendingSurveys &&
          pendingList && (
            <Col md={24} sm={24} xs={24}>
              <Card
                className="hls-container"
                title={t("THANKYOU.FAMILY_SURVEY_TITLE")}
                headStyle={{ fontWeight: "normal", textAlign: "left" }}
                extra={
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<RightOutlined />}
                    onClick={handlePendingSurvey}
                    style={styles.button}
                    id="thankyou-family-survey-btn"
                  />
                }
              >
                <div className="card-body thank-container 4">
                  <PendingSurveyListThankYou
                    surveyList={portalMicrositeSession.pendingSurveys}
                    onSelectSurvey={(surveyMeta: any) => {
                      console.log(surveyMeta);
                    }}
                  />
                </div>
              </Card>
            </Col>
          )}
      </Row>
    </div>
  );
};
export default ThankYou;
